import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ITVRCVRFormMeta {
  // Terminal Verification Results
  offlineAuthenticationPerformed: FormInputMeta;
  staticDataAuthenticationPassed: FormInputMeta;
  chipDataPresent: FormInputMeta;
  panOrTerminalExceptionFile: FormInputMeta;
  chipAndTerminalDifferentVersions: FormInputMeta;
  expiredApplication: FormInputMeta;
  applicationActive: FormInputMeta;
  //
  serviceAllowedForCardProduct: FormInputMeta;
  newCard: FormInputMeta;
  cardholderVerificationPassed: FormInputMeta;
  unrecognizedCvmOrother: FormInputMeta;
  pinTryExceeded: FormInputMeta;
  onlinePinEntered: FormInputMeta;
  //
  merchantForcedTransactionOnline: FormInputMeta;
  issuerAuthenticationFailed: FormInputMeta;
  transactionExceedsFloorLimit: FormInputMeta;
  lowerOfflineLimitExceeded: FormInputMeta;
  upperOnlineLimitExceeded: FormInputMeta;
  transactionSelectedRandomlyForOnline: FormInputMeta;
  // 
  pinEntryRequiredPinPadNotWorkingPresent: FormInputMeta;
  pinEntryRequiredNotEnteredPinPadPresent: FormInputMeta;
  scriptProcessingFailedBeforeGeneratingFinalCryptogram: FormInputMeta;
  scriptProcessingFailedAfterGeneratingFinalCryptogram: FormInputMeta;

  // Card Verification results
  firstCryptogramType: FormInputMeta;
  secondCryptogramType: FormInputMeta;
  numberOfIssuerScriptCommand: FormInputMeta;
  // 
  issuerAuthenticationPerformedOnLastTransaction: FormInputMeta;
  issuerAuthenticationFailedOnLastTransaction: FormInputMeta;
  issuerScriptProcessingFailed: FormInputMeta;  
  issuerAuthenticationFailedCVR: FormInputMeta;
  offlinePinVerificationPerformed : FormInputMeta;
  offlinePinVerificationFailed: FormInputMeta;
  // 
  unableToGoOnline: FormInputMeta;
  SDA : FormInputMeta;
  lastOnlineTransactionIncomplete: FormInputMeta;  
  pinTryLimitExceeded: FormInputMeta;
  velocityCheckingCountersExceeded: FormInputMeta;
  newCardCVR: FormInputMeta;
  pinTryLimitExceededAndApplicationBlocked: FormInputMeta;
  

  schema: any;
}

const TVRCVRFormMeta = {} as ITVRCVRFormMeta;
// Terminal Verification Results
TVRCVRFormMeta.offlineAuthenticationPerformed = {
  name: 'offlineAuthenticationPerformed',
  type: 'checkbox',
  label: 'Authentification hors ligne effectuée',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.staticDataAuthenticationPassed = {
  name: 'staticDataAuthenticationPassed',
  type: 'checkbox',
  label: 'Données statiques Authentification réussie',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.chipDataPresent = {
  name: 'chipDataPresent',
  type: 'checkbox',
  label: 'Données de puce présentes',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.panOrTerminalExceptionFile = {
  name: 'panOrTerminalExceptionFile',
  type: 'checkbox',
  label: 'Fichier d\'exception de la puce ou du terminal',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.chipAndTerminalDifferentVersions = {
  name: 'chipAndTerminalDifferentVersions',
  type: 'checkbox',
  label: 'Puce et terminal versions différentes',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.expiredApplication = {
  name: 'expiredApplication',
  type: 'checkbox',
  label: 'Application expirée',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
TVRCVRFormMeta.applicationActive = {
  name: 'applicationActive',
  type: 'checkbox',
  label: 'Application active',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

//
TVRCVRFormMeta.serviceAllowedForCardProduct = {
  name: 'serviceAllowedForCardProduct',
  type: 'checkbox',
  label: 'Service autorisé pour le produit de la carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.newCard = {
  name: 'newCard',
  type: 'checkbox',
  label: 'Nouvelle carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.cardholderVerificationPassed = {
  name: 'cardholderVerificationPassed',
  type: 'checkbox',
  label: 'Titulaire de la carte Vérification réussie',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.unrecognizedCvmOrother = {
  name: 'unrecognizedCvmOrother',
  type: 'checkbox',
  label: 'CVM non reconnu ou autre',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.pinTryExceeded = {
  name: 'pinTryExceeded',
  type: 'checkbox',
  label: 'Limite d\'essai du PIN dépassée',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
TVRCVRFormMeta.onlinePinEntered = {
  name: 'onlinePinEntered',
  type: 'checkbox',
  label: 'PIN en ligne saisi',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

//
TVRCVRFormMeta.merchantForcedTransactionOnline = {
  name: 'merchantForcedTransactionOnline',
  type: 'checkbox',
  label: 'Le commerçant a forcé la transaction en ligne',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.issuerAuthenticationFailed = {
  name: 'issuerAuthenticationFailed',
  type: 'checkbox',
  label: 'Échec de l\'authentification de l\'émetteur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.transactionExceedsFloorLimit = {
  name: 'transactionExceedsFloorLimit',
  type: 'checkbox',
  label: 'La transaction dépasse la limite inférieure',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.lowerOfflineLimitExceeded = {
  name: 'lowerOfflineLimitExceeded',
  type: 'checkbox',
  label: 'Limite inférieure hors ligne dépassée',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.upperOnlineLimitExceeded = {
  name: 'upperOnlineLimitExceeded',
  type: 'checkbox',
  label: 'Limite supérieure en ligne dépassée',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
TVRCVRFormMeta.transactionSelectedRandomlyForOnline = {
  name: 'transactionSelectedRandomlyForOnline',
  type: 'checkbox',
  label: 'Transaction sélectionnée aléatoirement pour l\'authentification en ligne',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

//
TVRCVRFormMeta.pinEntryRequiredPinPadNotWorkingPresent = {
  name: 'pinEntryRequiredPinPadNotWorkingPresent',
  type: 'checkbox',
  label: 'Entrée PIN requise. Présence d\'un PIN tampon, non fonctionnel ',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.pinEntryRequiredNotEnteredPinPadPresent = {
  name: 'pinEntryRequiredNotEnteredPinPadPresent',
  type: 'checkbox',
  label: 'Entrée PIN requise. Pas saisie. Présence d\'un PIN tampon',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.scriptProcessingFailedBeforeGeneratingFinalCryptogram = {
  name: 'scriptProcessingFailedBeforeGeneratingFinalCryptogram',
  type: 'checkbox',
  label: 'Le traitement du script a échoué avant la génération du cryptogramme final',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.scriptProcessingFailedAfterGeneratingFinalCryptogram = {
  name: 'scriptProcessingFailedAfterGeneratingFinalCryptogram',
  type: 'checkbox',
  label: 'Le traitement du script a échoué après la génération du cryptogramme final',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},


// Card Verification results
TVRCVRFormMeta.firstCryptogramType = {
  name: 'firstCryptogramType',
  type: 'text',
  label: 'Premier type de cryptogramme',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.secondCryptogramType = {
  name: 'secondCryptogramType',
  type: 'text',
  label: 'Deuxième type de cryptogramme',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.numberOfIssuerScriptCommand = {
  name: 'numberOfIssuerScriptCommand',
  type: 'text',
  label: 'Numéro de la commande de script de l\'émetteur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

// 
TVRCVRFormMeta.issuerAuthenticationPerformedOnLastTransaction = {
  name: 'issuerAuthenticationPerformedOnLastTransaction',
  type: 'checkbox',
  label: 'Authentification effectuée lors de la dernière transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.issuerAuthenticationFailedOnLastTransaction = {
  name: 'issuerAuthenticationFailedOnLastTransaction',
  type: 'checkbox',
  label: 'Échec de l\'authentification lors de la dernière transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.issuerScriptProcessingFailed = {
  name: 'issuerScriptProcessingFailed',
  type: 'checkbox',
  label: 'Échec du traitement du script de l\'émetteur',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.issuerAuthenticationFailedCVR = {
  name: 'issuerAuthenticationFailedCVR',
  type: 'checkbox',
  label: 'Échec de l\'authentification de l\'émetteur CVR',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.offlinePinVerificationPerformed = {
  name: 'offlinePinVerificationPerformed',
  type: 'checkbox',
  label: 'Vérification hors ligne du PIN',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
TVRCVRFormMeta.offlinePinVerificationFailed = {
  name: 'offlinePinVerificationFailed',
  type: 'checkbox',
  label: 'Echec de la vérification hors ligne de l\'identifiant',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

// 
TVRCVRFormMeta.unableToGoOnline = {
  name: 'unableToGoOnline',
  type: 'checkbox',
  label: 'Impossible d\'aller en ligne',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.SDA = {
  name: 'SDA',
  type: 'checkbox',
  label: 'SDA',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.lastOnlineTransactionIncomplete = {
  name: 'lastOnlineTransactionIncomplete',
  type: 'checkbox',
  label: 'Dernière transaction en ligne incomplète',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.pinTryLimitExceeded = {
  name: 'pinTryLimitExceeded',
  type: 'checkbox',
  label: 'Limite d\'essai du PIN dépassée',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.velocityCheckingCountersExceeded = {
  name: 'velocityCheckingCountersExceeded',
  type: 'checkbox',
  label: 'Dépassement des compteurs de vérification de la vélocité',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
TVRCVRFormMeta.newCardCVR = {
  name: 'newCardCVR',
  type: 'checkbox',
  label: 'Nouvelle carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
TVRCVRFormMeta.pinTryLimitExceededAndApplicationBlocked = {
  name: 'pinTryLimitExceededAndApplicationBlocked',
  type: 'checkbox',
  label: 'Limite d\'essai du PIN dépassée et application bloquée',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}


TVRCVRFormMeta.schema = yup.object().shape(getValidationSchema(TVRCVRFormMeta));

export default TVRCVRFormMeta;